import dashboardHomepageMenuOpen3xPng from '@listening/assets/astro/images/dashboard---homepage---menu-open3x.png';
import { createFileRoute } from '@tanstack/react-router';
import { DownloadsHero } from '@/components/astro/new-design-25/Downloads/download-hero';
import { FAQButton } from '@/components/astro/new-design-25/ui/FAQ-Button';
import { Footer } from '@/components/astro/new-design-25/ui/Footer';
import { NavBar } from '@/components/astro/new-design-25/ui/NavBar';
import { TryListeningBanner } from '@/components/astro/new-design-25/ui/TryListeningBanner';
import { GridBackground } from '@/components/shared-ui/grid-background';
import * as m from '@/paraglide/messages';
import { hreflangLinks, seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/downloads')({
  head: () => ({
    meta: [
      ...seo({
        title: m.meta_downloads_title(),
        description: m.meta_downloads_description(),
      }),
    ],
    links: [...hreflangLinks('/downloads')],
  }),
  component: () => (
    <>
      <a
        className='sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4'
        href='#main-content'
      >
        {m.skip_to_main_content()}
      </a>

      <div className='relative'>
        <GridBackground>
          <div className='relative z-10'>
            <NavBar />
            <main id='main-content' tabIndex={-1}>
              <DownloadsHero />
            </main>
          </div>
        </GridBackground>
      </div>

      <section className='relative z-10 flex flex-col items-center justify-center overflow-hidden px-5 py-8 sm:p-14 lg:p-18'>
        <div className='mx-auto flex w-full max-w-[1296px] flex-col items-center'>
          <img
            alt='Dashboard'
            className='static block h-auto max-w-full flex-1 overflow-hidden rounded-[10px] object-cover [box-shadow:0_5px_43px_rgba(193,_216,_251,_.5)] sm:rounded-[40px] lg:left-0 lg:h-full'
            loading='eager'
            src={dashboardHomepageMenuOpen3xPng}
          />
        </div>
      </section>
      <div role='complementary'>
        <FAQButton />
        <TryListeningBanner />
        <Footer />
      </div>
    </>
  ),
});
